import angular from "angular"

angular.module("uCountitUiApp").directive("announcement", [
  function () {
    return {
      restrict: "E",
      scope: {
        announcement: "=",
      },
      templateUrl: "components/announcement/announcement.html",
      link: function (scope, element, attrs) {
        scope.isAnnouncementVisible = false
        scope.dontShowAgain = false

        scope.open = function () {
          if (scope.announcement._id in JSON.parse(localStorage.getItem("announcements") || "{}")) {
            return
          }
          const now = new Date()
          if (new Date(scope.announcement.from) > now || new Date(scope.announcement.to) <= now) {
            return
          }
          scope.isAnnouncementVisible = true
        }

        scope.openUrl = function () {
          if (scope.announcement.url) {
            window.open(scope.announcement.url, "_blank")
          }
        }

        scope.close = function () {
          if (scope.dontShowAgain) {
            const hiddenAnnouncements = JSON.parse(localStorage.getItem("announcements") || "{}")
            hiddenAnnouncements[scope.announcement._id] = Date.now()
            localStorage.setItem("announcements", JSON.stringify(hiddenAnnouncements))
          }
          scope.isAnnouncementVisible = false
        }

        scope.open()
      },
    }
  },
])
